<app-timeline-transport-edit-job></app-timeline-transport-edit-job>
<app-timeline-transport-add-note></app-timeline-transport-add-note>

<div class='timelineToolbarContainer'>
  <div class='toolbarGroups'>
    <div class='toolbarGroup'>
      <button class='btn btn-secondary' (click)='addRow()'><i class="fas fa-plus"></i> New Unit</button>
      <input type='date' class='form-control' [(ngModel)]="this.copyDate" style='display:inline-block;width: 8rem;' />
      <button class='btn btn-secondary' (click)='copyJobs()'><i class="fas fa-copy"></i> Copy Jobs</button>
      <!-- <button class='btn btn-secondary'><i class="fas fa-copy"></i> Assign PO Number</button> -->
    </div>

    <!-- <div class='toolbarDivider'></div>

    <button class='btn btn-secondary'  data-toggle="tooltip" data-placement="top"
      title="Undo" (click)='undoAction()'><i class="fas fa-fw fa-backward"></i> Undo</button> -->

    <div class='toolbarDivider'></div>

    <div class='toolbarGroup'>
      <button class='btn btn-secondary' (click)='this.downloadSheet()'><i class="fas fa-file-pdf"></i> Download sheet</button>
    </div>

    <div class='toolbarDivider'></div>

    <div class='toolbarGroup'>
      <input
        type='text'
        class='form-control'
        placeholder='Search units...'
        style='width: 10rem;'
        [(ngModel)]='this.unitSearchTerm'
        (ngModelChange)='this.onUnitSearchChanged($event)'
        />
      <select class='form-control' [(ngModel)]='this.statusFilter' (ngModelChange)='this.onStatusFilterChanged($event)'>
        <option value='all'>All statuses</option>
        <option value='pending'>Pending</option>
        <option value='approved'>Approved</option>
        <option value='completed'>Completed</option>
        <option value='invoiced'>Invoiced</option>
      </select>
      @if (this.unitSearchTerm.trim() !== '') {
        <small class='toolbarSearchHint'>Clear search to reorder units</small>
      }
    </div>
  </div>

  <div class='toolbarGroup'>
    @if (this.connectedUsers.length > 0) {
      <div class='presenceChips' title='Also viewing this date'>
        @for (connectedUser of this.connectedUsers; track connectedUser) {
          <img
            class='presenceChip'
            src='https://eu.ui-avatars.com/api/?name={{ connectedUser.firstName }}+{{ connectedUser.lastName }}&size=24'
            [attr.title]='connectedUser.firstName + " " + connectedUser.lastName'
            />
        }
      </div>
    }

    <button class='chatToggleButton' (click)='this.toggleChat()' title='Chat'>
      <i class="fas fa-comments"></i>
      @if (this.unreadChatCount > 0) {
        <span class='chatUnreadBadge'>{{ this.unreadChatCount }}</span>
      }
    </button>

    <div class="dateSelectorContainer">
      <button class="btn btn-primary" (click)='this.prevDay()'><i class="fas fa-chevron-left"></i></button>
      <div class="dateSelectorBox" (click)='this.toggleDatePicker($event)'>
        <span><i class="fas fa-calendar-alt" style='font-size: 0.8rem'></i>&nbsp;&nbsp; {{ getFormattedDate() }}</span>
      </div>
      <button class="btn btn-primary" (click)='this.nextDay()'><i class="fas fa-chevron-right"></i></button>
    </div>

    <div class='vehicleTypeSwitcher' role='group'>
      @for (vType of vehicleTypes; track vType) {
        <button
          type='button'
          class='btn btn-secondary'
          [class.active]='vType.value === this.orderTypeId'
          (click)='this.onOrderTypeChanged(vType.value)'
          >{{ vType.type }}</button>
      }
    </div>
  </div>
</div>

@if (this.isDatePickerVisible) {
  <bs-datepicker-inline
    (bsValueChange)='this.onDateSelected($event)'
    [bsValue]='this.date'
    class='datePicker'
    [style.top.px]='this.datePickerTop'
    [style.left.px]='this.datePickerLeft'
    (click)='$event.stopPropagation()'
    ></bs-datepicker-inline>
}

@if (this.selectedJobs.length > 0) {
  <div class='toolbarGroup toolbarSelectionRow' title='Acts on the currently selected job(s)'>
    <span class='toolbarSelectionCount'>{{ this.selectedJobs.length }} selected</span>
    <button  class='btn btn-danger' data-toggle="tooltip" data-placement="top"
      title="Remove Job" (click)='this.onDeletedJobClicked()'><i class="fas fa-ban"></i> Remove</button>
    <button class='btn btn-success' data-toggle="tooltip" data-placement="top"
      title="Approve Job" (click)='this.onApproveJobClicked()'><i class="fas fa-check-circle"></i> Approve</button>
    <button class='btn btn-warning'  data-toggle="tooltip" data-placement="top"
      title="Unapprove Job" (click)='this.onUnapproveJobClicked()'><i class="fas fa-undo"></i> Unapprove</button>
    <button class='btn btn-primary'  data-toggle="tooltip" data-placement="top"
      title="Edit Job" (click)='onEditJobClicked()'><i class="fas fa-edit"></i> Edit</button>
    <button class='btn btn-info'  data-toggle="tooltip" data-placement="top"
      title="Add note" (click)='onAddNoteClicked()'><i class="fas fa-fw fa-sticky-note"></i> Add note</button>

    <div class='toolbarDivider toolbarDividerLight'></div>

    <div class='colorCodeContainer'>
      <span class='colorCodeKeyLabel'>Key:</span>
      <span class='colorCodeChip'><span class='colorCodeSwatch' style='background: #64748b;'></span> Pending</span>
      <span class='colorCodeChip'><span class='colorCodeSwatch' style='background: #3f8f5f;'></span> Approved</span>
      <span class='colorCodeChip'><span class='colorCodeSwatch' style='background: #6b5b95;'></span> Completed</span>
      <span class='colorCodeChip'><span class='colorCodeSwatch' style='background: #006498;'></span> Invoiced</span>
    </div>
  </div>
}

@if (this.selectedAssignments.length > 0) {
  <div class='toolbarGroup toolbarSelectionRow' title='Acts on the currently selected unit(s)'>
    <span class='toolbarSelectionCount'>{{ this.selectedAssignments.length }} unit(s) selected</span>
    <button class='btn btn-secondary' (click)='this.addDriverNote()'><i class="fas fa-file-pdf"></i> Add Driver note</button>
  </div>
}
